export default __webpack_public_path__ + "static/media/front.43bb9dd3.PNG";